
const HonorsHero = () => {
  return (
    <section 
      className="relative h-[500px] lg:h-[600px] flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('https://public.readdy.ai/ai/img_res/5e0b45a1979057ef61119613a42a5293.jpg')"
      }}
    >
      <div className="absolute inset-0 bg-black/40"></div>
      
      <div className="relative z-10 text-center text-white px-6 lg:px-16 max-w-4xl">
        <div className="mb-6">
          <div className="w-16 h-16 lg:w-20 lg:h-20 mx-auto mb-4 bg-accent/20 rounded-full flex items-center justify-center backdrop-blur-sm">
            <i className="ri-award-line text-2xl lg:text-3xl text-accent"></i>
          </div>
        </div>
        
        <h1 className="text-3xl lg:text-5xl font-bold font-serif mb-4 leading-tight">
          荣誉认证
        </h1>
        
        <p className="text-lg lg:text-xl mb-6 text-gray-200 leading-relaxed max-w-2xl mx-auto">
          三百年传承，现代荣誉见证<br />
          马帮瑞贡以品质赢得信赖，以匠心铸就辉煌
        </p>
        
        <div className="flex flex-wrap justify-center items-center gap-4 lg:gap-8 text-sm">
          <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
            <i className="ri-government-line text-accent"></i>
            <span>中央政府采购供应商</span>
          </div>
          <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
            <i className="ri-star-line text-accent"></i>
            <span>上海合作组织国宾伴手礼</span>
          </div>
          <div className="flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
            <i className="ri-plant-line text-accent"></i>
            <span>有机茶园认证</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HonorsHero;
